function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import requiredImage from '../fragments/requiredImage.js';
import link from './link.js';
var schema = defineObject('smallLogoCarouselSectionCard', {
    logo: _object_spread({
        title: 'Logo'
    }, requiredImage.fragment),
    link: {
        type: 'link',
        title: 'Link'
    }
}, [
    link.schema.link
]);
var validator = z.object({
    _type: z.literal('smallLogoCarouselSectionCard'),
    logo: requiredImage.validator.optional(),
    link: link.validator.optional()
});
schema.smallLogoCarouselSectionCard;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=smallLogoCarouselSectionCard.js.map